import React from "react";
import PropTypes from "prop-types";
import { SvgIcon, makeStyles } from "@material-ui/core";

export default function FeatureCard(props) {
  const { icon, text } = props.planFeature;

  const useStyles = makeStyles(theme => ({
    ratingText: {
      color: theme.palette.primary.main,
    },
    lightBackground: {
      backgroundColor: `${theme.palette.primary.main}16`,
    },
  }));

  const classes = useStyles();

  return (
    <li>
      <div className={`icon-container ${classes.lightBackground}`}>
        <SvgIcon component={icon} color='primary' />
      </div>
      <div className="feature-card-text">
      {text}
      </div>
    </li>
  );
}

FeatureCard.propTypes ={
  planFeature: PropTypes.object.isRequired,
}




// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Cards/FeatureCard.js